import React, { useEffect, useRef, useState } from 'react';
import Parser from 'html-react-parser';
import { notificationIcon } from 'assets';
import {
  GetNotifications,
  SetNotificationsStatusToRead,
  DeleteNotifications,
} from 'api';
import DateService from 'core/date.service';
import './notification-message.css';
import styles from './styles.module.css';

/* eslint-disable react/function-component-definition */
const NotificationsBell = () => {
  // State
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const hasNewNotification = notifications.some((o) => !o.isRead);

  // Refs
  const notificationsRef = useRef(null);
  const notificationIconRef = useRef(null);

  const handleGetNotifications = () => {
    GetNotifications({
      includeDeleted: false, // Does not fetch the notification marked as deleted
      onSuccess: (res) => {
        const newNotification = res.notifications
          .filter((item) => !item.deleted) // Do not display the notification marked as deleted
          .map((item) => ({
            ...item,
            message: Parser(
              item.message.replace(
                'vaiDateCreated',
                DateService.toLocalTime(item.createdDate, item.dateFormat)
              )
            ),
          }));
        setNotifications(newNotification);
      },
    });
  };

  const handleOpenNotifications = () => {
    setShowNotifications((prevState) => !prevState);

    setTimeout(() => {
      setNotifications((prevState) =>
        prevState.map((item) => ({
          ...item,
          isRead: true,
        }))
      );
    }, 500);

    SetNotificationsStatusToRead({});
  };

  const handleDeleteNotifications = () => {
    if (notifications.length > 0) {
      DeleteNotifications({});
      setNotifications([]);
    }
  };

  const RenderNotificationsPopout = () => {
    return (
      <div ref={notificationsRef}>
        <div className={styles.triangleShape} />

        <div className={styles.notifications}>
          <div className={styles.notificationHeader}>
            <span className={styles.notificationTitle}>Notifications</span>
            <span
              className={`${styles.clearAll} ${
                notifications.length === 0 ? styles.disabledClearAll : ''
              }`}
              onClick={handleDeleteNotifications}
            >
              Clear all
            </span>
          </div>

          <div className={styles.notificationContent}>
            {notifications.map((o) => (
              <div
                key={o.id}
                className={`${styles.notificationMessageWrapper} ${
                  !o.isRead ? styles.highlightFade : ''
                }`}
              >
                <div>{o.message}</div>
              </div>
            ))}
          </div>

          <div className={styles.notificationFooter} />
        </div>
      </div>
    );
  };

  const backdropClicked = (e) => {
    if (
      !notificationIconRef.current.contains(e.target) &&
      !notificationsRef.current?.contains(e.target)
    ) {
      setShowNotifications(false);
    }
  };

  useEffect(() => {
    handleGetNotifications();

    /**
     * This implements polling to fetch notifications every minute.
     * We should consider refactoring this in the future with WebSockets or SSE.
     */
    const interval = setInterval(() => {
      handleGetNotifications();
    }, 60000);

    document.addEventListener('mousedown', backdropClicked);

    return () => {
      clearInterval(interval);
      document.removeEventListener('mousedown', backdropClicked);
    };
  }, []);

  return (
    <div className={styles.notificationIconWrapper}>
      {hasNewNotification && <div className={styles.redDot} />}

      <img
        ref={notificationIconRef}
        className={styles.notificationIcon}
        src={notificationIcon}
        title="Notifications"
        alt="notification-icon"
        onClick={handleOpenNotifications}
      />

      {showNotifications && <RenderNotificationsPopout />}
    </div>
  );
};

export default NotificationsBell;
